import requestSecondStep from "./request-simple-second-step";

function decodeState(state) {
	return atob(state);
}
function JSONifyState(string) {
	return JSON.parse(string);
}
function getState() {
	let params = new URLSearchParams(document.location.search);
	return params.get('state');
}
function getJsonState(string) {
	let decodedString = decodeState(string);
	return JSONifyState(decodedString);
}

function  hiddenFirstForm() {
	$('#request-simple').addClass('is-hidden');
	$('#request-simple-second-step').removeClass('is-hidden');

}
function createInput(name, value, type) {
	const input = document.createElement('input');
	input.type = type;
	input.id = name;
	input.value = value;

	if (type === 'hidden') {
		input.classList.add('is-hidden');
	}
	let currentForm = $('#request-simple-second-step');
	currentForm.append(input);
}

function OpenSecondStepForm(token, phone) {
	requestSecondStep.init(token, phone);
}

function setStateForm(key, value) {
	let form = localStorage.getItem('form') ?? null;

	if (form) {
		let formJSON = JSON.parse(form);
		formJSON[key] = value;
		localStorage.setItem('form', JSON.stringify(formJSON));
	}
}

function getFormattedTime(unix_timestamp) {
// Create a new JavaScript Date object based on the timestamp
// multiplied by 1000 so that the argument is in milliseconds, not seconds
	let date = new Date(unix_timestamp);
// Hours part from the timestamp
	let hours = date.getHours();
// Minutes part from the timestamp
	let minutes = "0" + date.getMinutes();
// Seconds part from the timestamp
	let seconds = "0" + date.getSeconds();
// Will display time in 10:30:23 format
	return hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
}
function init() {
	let state = getState();

	if (state) {

		function encodeState(state) {
			return btoa(state);
		}

		let DOMFormId = document.getElementById("section-request");
		if (DOMFormId) {
			if (document.body.clientWidth > 1024) {
				let formDistanse = document.getElementById("section-request").offsetTop;
				scrollbar.scrollTo(0, formDistanse, 0, {
					// easing: easing.easeInOut,
				});
			} else {
				DOMFormId.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
			}

		}


		let jsonState = getJsonState(state);

		let currentTime = Date.now();
		let tokenExpired = jsonState.modifiedAt;



		let form = JSON.parse(localStorage.getItem('form'));
		if (currentTime < tokenExpired && !!form && form?.token === jsonState?.token) {
			hiddenFirstForm();
			createInput('phoneNumber', form.phone ? form.phone : 'test', 'hidden');
			OpenSecondStepForm(jsonState.auth, form.phone);
		} else {
			localStorage.removeItem('form');
		}
		document.cookie = "formState=; max-age=-1";
	}
}
export default {
	init,
};
